import type { PendingAction } from './hook'

type Translate = (key: string, params?: Record<string, string>) => string

const text = (value: unknown) => (typeof value === 'string' ? value.trim() : '')

/**
 * The sentence of a confirmation card, in the language of the app. Falls back
 * on the server's own (French) sentence when the name is missing: an older
 * server sends no `targetLabel` for an update or a deletion.
 */
export const describeAction = (t: Translate, action: PendingAction): string => {
  const { toolName, args } = action
  let name = ''
  switch (toolName) {
    case 'createNote':
      name = text(args.title)
      break
    case 'createCategory':
    case 'createHashtag':
      name = text(args.name)
      break
    case 'createGhostProfile':
      name = `${text(args.firstName)} ${text(args.lastName)}`.trim()
      break
    case 'updateNote':
    case 'deleteNote':
    case 'updateGhostProfile':
    case 'deleteGhostProfile':
      name = text(action.targetLabel)
      break
    default:
      return action.description
  }
  return name ? t(`chatbot.actions.${toolName}`, { name }) : action.description
}
